<template>
    <b-modal :title="Core.Definition.getDefinition('Champ')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                :options="{}"
                :ignoreRouteParamId="true"
                :getRoot="options.root.get"
                :formStructure="dataFormStructures.form">
            <slot slot="beforeFormButtons">
                <slot name="formButtons"></slot>
            </slot>
            <slot slot="afterForm">

                <b-row v-if="this.dataFieldData.displaySettings.spreadsheet">
                    <b-col>
                        <table class="table">
                            <tbody>
                            <tr>
                                <td>
                                    {{Core.Definition.getDefinition('Rangées')}}
                                </td>
                                <td>
                                    <b-form-input v-model="dataFieldData.spreadsheet.settings.rowCount"></b-form-input>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{Core.Definition.getDefinition('Colonnes')}}
                                </td>
                                <td>
                                    <b-form-input v-model="dataFieldData.spreadsheet.settings.colCount"></b-form-input>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>

                <b-row v-if="dataFieldData.displaySettings.isRequired">
                    <b-col>
                        <InputCheckbox
                                v-model="dataFieldData.isRequired"
                                :label="Core.Definition.getDefinition('Champ obligatoire')">
                        </InputCheckbox>
                    </b-col>
                    <b-col>
                    </b-col>
                </b-row>

                <b-row v-if="dataFieldData.displaySettings.selectOptions">
                    <b-col>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th colspan="2">
                                        {{Core.Definition.getDefinition('Éléments')}}
                                    </th>
                                    <th>
                                        <b-link @click="onClickAddSelectOption" class="card-header-action"><i class="fa fa-plus"></i> {{Core.Definition.getDefinition('Ajouter')}}</b-link>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="fieldDataOption, fieldDataOptionIndex in dataFieldData.selectOptions">
                                    <td>
                                        <b-form-input :placeholder="Core.Definition.getDefinition('Libellé')" v-model="dataFieldData.selectOptions[fieldDataOptionIndex].label"></b-form-input>
                                    </td>
                                    <td></td>
                                    <td>
                                        <b-button @click="onClickTrashSelectOption(fieldDataOptionIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></b-button>
                                    </td>
                                </tr>
                                <tr v-if="dataFieldData.selectOptions.length == 0">
                                    <td colspan="3">
                                        {{Core.Definition.getDefinition('Aucun élément')}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>


            </slot>
        </DynamicForm>
    </b-modal>
</template>

<script>
    var _self
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from './DynamicForm'
    import InputText from './InputText'
    import InputQuantity from './InputQuantity'
    import InputCheckbox from './InputCheckbox'
    export default {
        name: 'ModalFormBuilderField',
        components: {
            DynamicForm,
            InputText,
            InputQuantity,
            InputCheckbox
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            get: '/'
                        }
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            isRequired: {
                set(val) {
                    this.dataFieldData.isRequired = val
                },
                get() {
                    return this.dataFieldData.isRequired
                }
            },
            selectOptions: {
                set(val) {
                    this.dataFieldData.selectOptions = val
                },
                get() {
                    return this.dataFieldData.selectOptions
                }
            },
            spreadsheet: {
                set(val) {
                    this.dataFieldData.spreadsheet = val
                },
                get() {
                    return this.dataFieldData.spreadsheet
                }
            },
            data: {
                set(val) {
                    this.dataFieldData = val
                },
                get() {
                    return this.dataFieldData
                }
            }
        },
        watch: {
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataType: '',
                dataSpreadsheetValue: [],
                dataFieldData: {
                    displaySettings:  {
                        selectOptions: false,
                        isRequired: false,
                        spreadsheet: false
                    },
                    isRequired: false,
                    selectOptions: [],
                    spreadsheet: {
                        settings: {
                            colCount: 6,
                            rowCount: 6,
                            cellsMeta: [],
                            colsWidth: []
                        }
                    }
                },
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'id'
                                                                    },
                                                                    {
                                                                        id: 'type'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'label'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'id',
                                type: 'hidden',
                                value: ''
                            },
                            {
                                id: 'type',
                                type: 'select',
                                label: Core.Definition.getDefinition('Type'),
                                value: null,
                                required: true,
                                options: Core.Value.fieldOptions([Core.Value.typeText, Core.Value.typeLongText, Core.Value.typeDate, Core.Value.typeCheckbox, Core.Value.typeSelect, Core.Value.typeHTML, Core.Value.typeImage, Core.Value.typeSpreadsheet, Core.Value.typeSignatureImage]),
                                onSelect: function(value, form, fieldRefs) {
                                    if (value && value.value) {
                                        _self.displaySettings(value.value)
                                    }
                                    _self.$forceUpdate()
                                }
                            },
                            {
                                id: 'label',
                                type: 'text',
                                label: Core.Definition.getDefinition('Libellé'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: '',
                                description: Core.Definition.getDefinition('Cette description sera visible en dessous du champs.')
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onRequestSuccess(data, method) {
                switch (method) {
                    case Core.Request.methodGet:
                        if (data.form !== undefined) {
                            this.$refs.dynamicForm.$refs.form.fieldRefs['type'].dataValue = Core.Select.select(data.form.type, Core.Value.fieldOptions())
                        }
                        break
                }
            },
            onInitSuccess(data) {
                this.$emit('onInitSuccess', data)
            },
            displaySettings(type) {
                this.dataFieldData.displaySettings = {
                    selectOptions: false,
                    isRequired: false,
                    spreadsheet: false
                }
                this.dataType = type
                switch(type) {
                    case Core.Value.typeText:
                    case Core.Value.typeCheckbox:
                    case Core.Value.typeDate:
                        this.dataFieldData.displaySettings.isRequired = true
                        break
                    case Core.Value.typeSelect:
                        this.dataFieldData.displaySettings.isRequired = true
                        this.dataFieldData.displaySettings.selectOptions = true
                        break
                    case Core.Value.typeSpreadsheet:
                        this.dataFieldData.displaySettings.spreadsheet = true
                        break
                }
            },
            onClickAddSelectOption() {
                let value = this.dataFieldData.selectOptions.length
                this.dataFieldData.selectOptions.push({
                    label: '',
                    isDefault: false,
                    value: value
                })
            },
            onClickTrashSelectOption(selectOptionIndex) {
                this.dataFieldData.selectOptions.splice(selectOptionIndex, 1)
            },
            resetOptions() {
                this.dataFieldData.displaySettings = {
                    selectOptions: false,
                    isRequired: false,
                    spreadsheet: false
                }
                this.dataFieldData.isRequired = false
                this.dataFieldData.selectOptions = []
                this.dataFieldData.spreadsheet = {
                    settings: {
                        colCount: 6,
                        rowCount: 6,
                        cellsMeta: [],
                        colsWidth: []
                    }
                }
            },
            onChangeQuantity() {
            }
        }
    }
</script>
